import { getEnvironment } from '../../../shared/javascripts/util/environment'
import Deferred from '../modules/deferred'

let domReadDeferred = new Deferred()
let domReady = domReadDeferred.promise

document.addEventListener('DOMContentLoaded', () => { domReadDeferred.resolve() })

function sanitizeSecrets(object) {
  if (typeof object === 'string' || object instanceof String) {
    return object
      .replace(/(\/gutscheine\/).+?(\/|$)/, '$1GUTSCHEINCODE$2')
      .replace(/(\/buchungen\/).{20,}?(\/|$)/, '$1BUCHUNGSCODE$2')
  } else if (typeof object === 'object' && object instanceof Object) {
    Object.keys(object).forEach((key) => object[key] = sanitizeSecrets(object[key]))
    return object
  } else {
    return object
  }
}
export function trackEvent(eventName, eventData = {}) {
  domReady.then(() => {
    gtmPush({
      event: eventName,
      eventData: sanitizeSecrets(eventData),
      path: sanitizeSecrets(location.pathname),
      env: getEnvironment(),
    })
  })
}

export function trackElementInteraction(element, eventName, customEventData = {}) {
  let eventData

  if (element.nodeType === Node.DOCUMENT_NODE) {
    eventData = {
      element: {
        id: '#document',
        text: element.body.textContent.trim().replace(/\s+/g, ' '),
        ...customEventData
      }
    }
  } else {
    eventData = {
      element: {
        id: element.getAttribute('up-id') || element.getAttribute('class'),
        text: element.textContent.trim().replace(/\s+/g, ' '),
        ...customEventData
      }
    }
  }

  trackEvent(eventName, eventData)
}

function gtmPush(eventData) {
  if (eventData.env === 'development' || eventData.env === 'staging') {
    console.log('Tracking event', eventData)
  }
  // Track event through Google Tag Manager
  window.dataLayer.push(eventData)
}
